import React, { Component, createRef } from 'react'
import PropTypes from "prop-types"
import { Input } from "reactstrap"
import { Switch, Checkbox, Input as InputNumber, Select, Button, Table, message, Modal, Radio, Popconfirm, Spin } from "antd"
import { FileTextTwoTone, DeleteOutlined, EyeTwoTone, UploadOutlined, LoadingOutlined } from '@ant-design/icons'
import { uploadImageSku } from "../../../services/api/apiSku"
import className from "classnames"
import LazyLoad from 'react-lazyload'
import ModalBrandDescriptionPackaged from './ModalBrandDescriptionPackaged'

class SkuInfo extends Component {
    state = {
        isLoading: false,
        isOpenPreview: false,
        imageSelect: '',
        isOpenDescribeBrand: false,
    }

    inputFileRef = createRef()

    _handleChangeInput = (e) => {
        const { onChange } = this.props
        const { name, value } = e.target

        if (typeof onChange === 'function') {
            onChange(name, value.trim())
        }
    }

    _handleChangeMaterials = (e) => {
        const { onChange } = this.props
        const { name, value } = e.target

        if (typeof onChange === 'function') {
            onChange(name, value)
        }
    }

    _handleChangeSwitch = (value) => {
        const { onChange } = this.props

        if (typeof onChange === 'function') {
            onChange('is_active', value)
        }
    }

    _switchNeedManageMaterials = (value) => {
        const { onChange } = this.props

        if (typeof onChange === 'function') {
            onChange('need_manage_materials', value)
        }
    }

    _checkMex = () => {
        const { onChange, is_mex } = this.props

        if (typeof onChange === 'function') {
            onChange('is_mex', !is_mex)
        }
    }

    _hanldeCheckIsEmbroidery = () => {
        const { onChange, is_embroidery, onMakeEmbroidery } = this.props

        if (typeof onChange === 'function') {
            onChange('is_embroidery', !is_embroidery)
            onMakeEmbroidery()
        }
    }

    _handleDescribeModal = (field, value) => {
        this.setState({
            [field] : value
        })
    }

    _handleOpenDescribeBrand = (isOpen) => {
        this.setState({ isOpenDescribeBrand: isOpen })
    }

    _handleAddImage = () => {
        if (this.inputFileRef.current) {
            this.inputFileRef.current.click()
        }
    }

    _handleRemoveImage = (e, imageUrl) => {
        e.stopPropagation()
        const {onRemoveImageDescribe} = this.props
        onRemoveImageDescribe(imageUrl)
    }

    handleFileChange = async (event) => {
        this.setState({isLoading: true})
        const file = event.target.files[0]
        const validImageTypes = ['image/png', 'image/jpeg', 'image/jpg']

        const {onAddImageDescribe, skuID} = this.props
        const maxSize = 10 * 1024 * 1024 // 10MB
        if(!file) return this.setState({isLoading: false})
        
        if (file && file.size > maxSize) {
            message.error('File phải nhỏ hơn 10MB.')
            this.setState({isLoading: false})
            return
        }

        if (file && !validImageTypes.includes(file.type)){
            message.error('Chỉ hỗ trợ định dạng [image/png,image/jpeg,image/jpg].')
            this.setState({isLoading: false})
            return
        }

        try {
            const formData = new FormData()
            file && formData.append('file', file)
            skuID && formData.append('objectId', skuID)
            formData.append('objectName', 'Sku')
    
            const {data} = await uploadImageSku(formData)
            const {data : res, success, message: mess} = Object.assign({}, data)
            if(!success) return message.error(mess)
    
            onAddImageDescribe(res)
            if(!!this.inputFileRef.current) this.inputFileRef.current.value = null
        } catch (error) {
            message.error(error.message)
        }finally{
            this.setState({isLoading: false})
        }
    }

    render() {
        const {
            skuID,
            error,
            validateName,
            name,
            sku,
            procedure,
            export_by,
            is_active,
            flow,
            materials = '',
            description,
            commitment_time,
            validateTime,
            need_manage_materials,
            packed_description,
            is_mex,
            listPartner = [],
            partner,
            validatePartner,
            meta = {},
            commitment_time_fast_production,
            production_process,
            is_embroidery,
            listProductionProcess,
            packageMockup,
            brandOptions,
            brandsDescriptionPackaged,
            onChangeBrandsDescriptionPackaged,
            actionUpdate,
            getDetailSku,
        } = this.props
        console.log('brandsDescriptionPackaged', brandsDescriptionPackaged)
        const {isLoading, isOpenPreview, imageSelect, isOpenDescribeBrand} = this.state
        const { material, production_method } = meta
        const isPartnerGlobal = !!listPartner.length && !!listPartner.find(i => !!i._id && i._id === partner) && listPartner.find(i => !!i._id && i._id === partner).name === "MC Lab"
        const processOptions = listProductionProcess.map(i => ({ label: i.name, value: i._id, partner: i.partner }))

        return (
            <div className="SkuInfo mb-3">
                <h3 className="font-weight-bold">Thông tin chung</h3>

                {error && <div className="mt-3 text-danger">{error}</div>}

                <div className="d-flex Skuinfo flex-wrap align-items-start">
                    <div className="itemInfo mr-5 mb-3 d-flex align-items-center">
                        <label className="font-weight-bold mb-0 mr-2">Tên:</label>
                        <Input
                            invalid={validateName !== '' && validateName.length > 0}
                            type='text'
                            name='name'
                            value={name}
                            placeholder='Nhập tên ...'
                            style={{ "width": 300 }}
                            onChange={this._handleChangeInput}
                            disabled
                        />
                        {
                            validateName !== '' && validateName.length > 0 &&
                            <div className="NameValidate text-danger ml-2">{validateName}</div>
                        }
                    </div>

                    <div className="itemInfo mr-5 mb-3 d-flex flex-column">
                        <div className='partner d-flex align-items-center'>
                            <label className='font-weight-bold mb-0 mr-2'>Partner sản xuất:</label>
                            <select
                                className={`${className('form-control')} ${validatePartner !== '' && validatePartner.length > 0 && !partner && 'is-invalid'}`}
                                value={partner}
                                name="partner"
                                style={{ "width": 200 }}
                                onChange={this._handleChangeInput}
                                disabled
                            >
                                <option value="">None</option>
                                {!!listPartner && listPartner.length > 0 && listPartner.map((i, index) => (
                                    <option key={index} value={i._id}>{i.name}</option>
                                ))}
                            </select>
                        </div>
                        {
                            validatePartner !== '' && validatePartner.length > 0 &&
                            <div className=" text-danger ml-2 mt-1 text-right">{validatePartner}</div>
                        }
                    </div>

                    <div className="itemInfo mb-3 mr-5 d-flex align-items-center">
                        <label className='font-weight-bold mb-0 mr-2'>Export by:</label>
                        <select
                            className={className('form-control')}
                            value={export_by}
                            name="export_by"
                            style={{ "width": 200 }}
                            onChange={this._handleChangeInput}
                        >
                            <option value="">None</option>
                            <option value="side">Side</option>
                            <option value="size">Size</option>
                        </select>
                    </div>

                    <div className="itemInfo mr-5 mb-3 d-flex align-items-center">
                        <label className="font-weight-bold mb-0 mr-2">Quy trình:</label>
                        <select
                            className={className('form-control')}
                            value={procedure}
                            name="procedure"
                            style={{ "width": 200 }}
                            onChange={this._handleChangeInput}
                        >
                            <option value="2D">2D</option>
                            <option value="3D">3D</option>
                        </select>
                    </div>

                    <div className="itemInfo mr-5 mb-3 d-flex align-items-center">
                        <label className="font-weight-bold mb-0 mr-2 Type">Loại:</label>
                        <Input
                            type='text'
                            name='sku'
                            value={sku}
                            placeholder='Nhập loại ...'
                            style={{ "width": 300 }}
                            disabled={true}
                        />
                    </div>
                    <div className="itemInfo mb-3 mr-5 d-flex align-items-center">
                        <label className="font-weight-bold mb-0 mr-2 Flowproduction">Luồng sản xuất:</label>
                        <select
                            className={className('form-control')}
                            value={flow}
                            name="flow"
                            style={{ "width": 200 }}
                            onChange={this._handleChangeInput}
                        >
                            <option value="">None</option>
                            <option value="THANK_CARD">Thank you card</option>
                        </select>
                    </div>

                    <div className="itemInfo mr-5 mb-3 d-flex Description align-items-center">
                        <label className="font-weight-bold mb-0 mr-2 ">Mô tả:</label>
                        <div className="d-flex flex-column">
                            <Input
                                value={description}
                                type='textarea'
                                name='description'
                                className='form-control'
                                style={{ "width": 560 }}
                                placeholder={'Mô tả thông tin'}
                                onChange={this._handleChangeMaterials}
                            />
                            {!!brandOptions.length ?
                                <span className='mt-1 cursor-pointer' onClick={() => this._handleOpenDescribeBrand(true)}>
                                    <FileTextTwoTone style={{ fontSize: 14 }} /> Mô tả thông tin QCHT
                                </span> :
                                <span className='mt-1' style={{ pointerEvents: 'none' }}>
                                    <FileTextTwoTone style={{ fontSize: 14 }} disabled /> Mô tả thông tin QCHT
                                </span>
                            }
                            <ModalBrandDescriptionPackaged
                                skuID={skuID}
                                getDetailSku={getDetailSku}
                                actionUpdate={actionUpdate}
                                brandOptions={brandOptions}
                                isOpen={isOpenDescribeBrand}
                                brandsDescriptionPackaged={brandsDescriptionPackaged}
                                onChangeBrandsDescriptionPackaged={onChangeBrandsDescriptionPackaged}
                                onOpenDescribeBrand={this._handleOpenDescribeBrand}
                            />
                        </div>
                    </div>

                    <div className="itemInfo mr-5 mb-3 d-flex Materials align-items-center">
                        <label className="font-weight-bold mb-0 mr-2">Nguyên vật liệu:</label>
                        <Input
                            type='text'
                            name='materials'
                            value={(!!material && !!material.name && !!material.code) ? `${material.code} - ${material.name.toUpperCase()}` : materials}
                            placeholder='Nguyên vật liệu'
                            style={{ "width": isPartnerGlobal ? 300 : 660 }}
                            onChange={this._handleChangeInput}
                            disabled
                        />
                    </div>

                    {isPartnerGlobal && <div className="itemInfo mr-5 mb-3 d-flex Materials align-items-center">
                        <label className="font-weight-bold mb-0 mr-2">Phương pháp sản xuất:</label>
                        <Input
                            type='text'
                            placeholder='Phương pháp sản xuất'
                            value={(!!production_method && !!production_method.name && !!production_method.code) ? `${production_method.code} - ${production_method.name.toUpperCase()}` : ''}
                            style={{ "width": 200 }}
                            disabled
                        />
                    </div>}

                    <div className="itemInfo Description mr-5 mb-3 d-flex align-items-center">
                        <label className="font-weight-bold mb-0 mr-2">Mô tả đóng gói:</label>
                        {/* <div className="d-flex flex-column"> */}
                        <Input
                            value={packed_description}
                            type='textarea'
                            name='packed_description'
                            className='form-control'
                            style={{ "width": 560 }}
                            placeholder={'Mô tả thông tin'}
                            onChange={this._handleChangeMaterials}
                        />

                        {/* </div> */}
                    </div>
                    <div className="itemInfo mr-5 Switchstatus d-flex align-items-center">
                        <div className='d-flex mb-3 align-items-center'>
                            <label className="font-weight-bold mb-0 mr-2">Need manage materials:</label>
                            <Switch
                                defaultChecked={need_manage_materials}
                                checked={need_manage_materials}
                                checkedChildren="On"
                                unCheckedChildren="Off"
                                onChange={this._switchNeedManageMaterials}
                                className='mr-5'
                            />
                        </div>
                        <div className='d-flex mb-3 align-items-center'>
                            <label className="font-weight-bold mb-0 mr-2" style={{ width: 'unset' }}>Trạng thái:</label>
                            <Switch
                                defaultChecked={is_active}
                                checked={is_active}
                                checkedChildren="On"
                                unCheckedChildren="Off"
                                onChange={this._handleChangeSwitch}
                                className='mr-5'
                            />
                        </div>
                        <div className='d-flex mb-3 align-items-center'>
                            <label className="font-weight-bold mb-0 mr-2" style={{ width: 'unset' }}>Sản phẩm thêu:</label>
                            <Checkbox
                                defaultChecked={is_embroidery}
                                checked={is_embroidery}
                                onChange={this._hanldeCheckIsEmbroidery}
                            />
                        </div>
                        <div className='d-flex mb-3 align-items-center'>
                            <label className="font-weight-bold mb-0 mr-2" style={{ width: 'unset' }}>Ép Mex:</label>
                            <Checkbox
                                defaultChecked={is_mex}
                                checked={is_mex}
                                onChange={this._checkMex}
                            />
                        </div>
                    </div>

                    <div className="itemInfo mr-5 mb-3 d-flex align-items-center">
                        <label className="font-weight-bold mb-0 mr-2"></label>
                        {
                            !!packageMockup && !!packageMockup.length &&
                            <div className="d-flex align-items-center">
                                {
                                    packageMockup.map((item, index) => (
                                        <div className="image-item-upload mr-3 position-relative" key={index}>
                                            <LazyLoad>
                                                <img 
                                                    src={item} 
                                                    alt="preview"
                                                    loading='lazy'
                                                />
                                                <Popconfirm
                                                    placement="topRight"
                                                    title="Bạn chắc chắn muốn xóa ảnh này?"
                                                    onConfirm={(e) => this._handleRemoveImage(e, item)}
                                                    okText="Xóa"
                                                    cancelText="Không"
                                                >
                                                    <DeleteOutlined className='delete-image-item'/>
                                                </Popconfirm>
                                                <EyeTwoTone 
                                                    className='eyes-image-item'
                                                    onClick={() => this.setState({isOpenPreview: true, imageSelect: item})}
                                                />
                                                <Modal
                                                    visible={isOpenPreview && item === imageSelect}
                                                    onCancel={() => this.setState({isOpenPreview: false, imageSelect: ''})}
                                                    closable={false}
                                                    footer={false}
                                                    width={"50vw"}
                                                    height={"75vh"}
                                                >
                                                    <img
                                                        src={item}
                                                        alt="preview"
                                                        width={"100%"}
                                                        style={{ objectFit: 'contain' }}
                                                    />
                                                </Modal>
                                            </LazyLoad>
                                        </div>
                                    ))
                                }
                            </div>
                        }
                        {
                            packageMockup.length < 3 &&
                            <div className="d-flex align-items-center">
                                <Button
                                    type='default'
                                    icon={<UploadOutlined />}
                                    onClick={this._handleAddImage}
                                    loading={isLoading}
                                    disabled={isLoading}
                                >
                                    Thêm ảnh
                                </Button>
                            </div>
                        }
                        <input
                            type="file"
                            accept="image/*"
                            ref={this.inputFileRef}
                            hidden
                            onChange={this.handleFileChange}
                        />
                    </div>

                    <div className="itemInfo mb-3 mr-5 d-flex align-items-center">
                        <label className='font-weight-bold mb-0 mr-2'>Quy trình sản xuất:</label>
                        <select
                            value={production_process || ''}
                            name='production_process'
                            defaultValue={production_process || []}
                            placeholder='Time ...'
                            style={{ "width": 660 }}
                            onChange={this._handleChangeInput}
                            className='form-control'
                        >
                            <option value='' disabled={production_process}>None</option>
                            {!!processOptions && processOptions.length > 0 && processOptions.map((i, index) => (
                                (!!i.partner && !!i.partner.id && i.partner.id === partner) &&
                                <option key={`Process_${index}`} value={i.value}>{i.label}</option>
                            ))}
                        </select>
                    </div>

                    <div className="itemInfo mb-3 mr-5 d-flex align-items-center">
                        <label className='font-weight-bold mb-0 mr-2'>Thời gian cam kết:</label>
                        <Input
                            invalid={validateTime !== '' && validateTime.length > 0}
                            type='number'
                            name='commitment_time'
                            defaultValue={commitment_time}
                            placeholder='Time ...'
                            style={{ "width": 200 }}
                            onChange={this._handleChangeInput}
                        />
                    </div>

                    <div className="itemInfo mb-3 mr-5 d-flex align-items-center">
                        <label className='font-weight-bold mb-0 mr-2'>Thời gian sản xuất nhanh:</label>
                        <InputNumber
                            value={commitment_time_fast_production}
                            name='commitment_time_fast_production'
                            defaultValue={commitment_time_fast_production}
                            placeholder='Time ...'
                            style={{ "width": 200 }}
                            onChange={this._handleChangeInput}
                            className='form-control-fast-time'
                        />
                    </div>
                </div>
            </div>
        )
    }
}

SkuInfo.propTypes = {
    loading: PropTypes.bool,
    error: PropTypes.string,
    validateName: PropTypes.string,
    name: PropTypes.string,
    sku: PropTypes.string,
    procedure: PropTypes.string,
    export_by: PropTypes.string,
    is_active: PropTypes.bool,
    flow: PropTypes.string,
    materials: PropTypes.string,
    description: PropTypes.string,
    onChange: PropTypes.func
}

export default SkuInfo
